import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  props: {
    dictType: {
      type: Number,
      default: 1,
      required: true
    }
  },
  data: function data() {
    return {
      api: {
        detail: 'DICTDATA_DETAIL',
        create: 'DICTDATA_CREATE',
        update: 'DICTDATA_UPDATE'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      var dictValueNumber = {
        prop: 'dict_number',
        default: 0,
        label: '字典键值',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "min": 0
            },
            "model": {
              value: _this.form.model.dict_number,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "dict_number", $$v);
              }
            }
          });
        }
      };
      var dictValueString = {
        prop: 'dict_value',
        default: '',
        label: '字典键值',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.dict_value,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "dict_value", $$v);
              }
            }
          });
        }
      };
      var dictValue = this.dictType === 1 ? dictValueNumber : dictValueString;
      return [{
        prop: 'dict_id',
        default: this._.get(this.search, 'form.model.dict_id', ''),
        label: '字典',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("d2-dict", {
            "attrs": {
              "value": _this.form.model.dict_id,
              "name": "dict_id",
              "custom": true,
              "disabled": true
            }
          });
        }
      }, {
        prop: 'dict_label',
        default: '',
        label: '字典标签',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.dict_label,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "dict_label", $$v);
              }
            }
          });
        }
      }, dictValue, {
        prop: 'css_class',
        default: '',
        label: '样式属性',
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.css_class,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "css_class", $$v);
              }
            }
          });
        }
      }, {
        prop: 'list_class',
        default: '',
        label: '回显样式',
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.list_class,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "list_class", $$v);
              }
            }
          });
        }
      }, {
        prop: 'is_default',
        default: this.$env.VUE_APP_DICT_IS_FALSE,
        label: '系统默认',
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "is",
              "button": true
            },
            "model": {
              value: _this.form.model.is_default,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "is_default", $$v);
              }
            }
          });
        }
      }, {
        prop: 'dict_sort',
        default: this.$env.VUE_APP_FORM_SORT_MIN,
        label: '显示顺序',
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "min": _this.$env.VUE_APP_FORM_SORT_MIN
            },
            "model": {
              value: _this.form.model.dict_sort,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "dict_sort", $$v);
              }
            }
          });
        }
      }, {
        prop: 'status',
        default: this.$env.VUE_APP_DICT_STATUS_ACTIVE,
        label: '状态',
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "status",
              "button": true
            },
            "model": {
              value: _this.form.model.status,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "status", $$v);
              }
            }
          });
        }
      }, {
        prop: 'remark',
        default: '',
        label: '备注',
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.remark,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "remark", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: {
    /**
     * @description 加载需要的字典数据
     */
    loadDict: function loadDict() {
      // 字典
      this.loadDictOne({
        name: 'dict_id',
        method: this.$api.DICT_ALL,
        fields: 'dict_name,id',
        path: 'list',
        label: 'dict_name'
      });
    }
  }
};